import { Schema } from "effect";
import * as Multipart from "effect/http/Multipart";

/**
 * Exactly one uploaded file part, decoded as a one-element array. `Multipart.SingleFileSchema`
 * decodes to the file itself, but v4 then documents the part as a single binary string; v3
 * documented an array of exactly one file, and clients generated from the document depend on it.
 */
export const OneFileSchema = Multipart.FilesSchema.check(Schema.isBetweenLength(1, 1));
